(function () {
  'use strict';

  function initCounter(gallery) {

    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    var imageList = gallery.querySelector('.product-gallery__image-list');
    if (!imageList) return;

    // Remove any existing counter to avoid duplicates on re-init
    var existing = imageList.querySelector('.sw-gallery-counter');
    if (existing) existing.remove();

    // Cached once per init; variant changes trigger a full reinit via initAll
    var slides = Array.from(gallery.querySelectorAll('.product-gallery__media:not([hidden])'));

    if (slides.length < 2) return;

    imageList.style.position = 'relative';

    var counter = document.createElement('div');
    counter.className = 'sw-gallery-counter';
    counter.setAttribute('role', 'status');
    imageList.appendChild(counter);

    function getActiveIndex() {
      var carouselRect = carousel.getBoundingClientRect();
      var carouselCenter = carouselRect.left + carouselRect.width / 2;
      var closest = 0;
      var closestDist = Infinity;
      slides.forEach(function (slide, i) {
        var rect = slide.getBoundingClientRect();
        var slideCenter = rect.left + rect.width / 2;
        var dist = Math.abs(slideCenter - carouselCenter);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      return closest;
    }

    function update() {
      var idx = getActiveIndex();
      counter.textContent = (idx + 1) + ' / ' + slides.length;
      counter.setAttribute('aria-label', 'Image ' + (idx + 1) + ' of ' + slides.length);
    }

    update();

    carousel.addEventListener('scroll', update, { passive: true });
    carousel.addEventListener('scrollend', update, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('product-gallery').forEach(initCounter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('variant:change', initAll);
})();
